import React, { useEffect, useState } from 'react'
import { getDatabase, ref, update,push,child,get} from "firebase/database";
import {app} from "../api.js";
import moment from 'moment';
import FileUp from './FileUp.js';
import { getAuth, signOut } from 'firebase/auth';
const auth = getAuth(app);

const db = getDatabase(app);
const dbRef = ref(getDatabase(app));

const Addbook = (props) => {

  const color =(index)=>{
    if ((index+1)% 2===0) {
      return "white"
    } else {
      return "#D5FFFC"
    }
  }

  const [Error, setError] = useState(null)
  const [Show, setShow] = useState(false)
  const [Data, setData] = useState([])

  const [id, setid] = useState('nome');

  useEffect(() => {
    console.log(id)
  }, [id])
  

  const total=()=>{
    let dr = 0;
    let cr = 0;
    for (let i = 0; i <Data.length; i++) {
      if (Data[i].dr) {
        dr = dr+parseFloat(Data[i].dr)
      }
      if (Data[i].cr) {
        cr = cr+parseFloat(Data[i].cr) 
      }
    }

    return {dr:dr,cr:cr}
  }




const [Entry, setEntry] = useState({
  title:"",
  dr:'',
  cr:0,
  date:moment(new Date()).format('yyyy-MM-DD'),
  id:props.uid.uid,
  name:props.uid.displayName,
  email:props.uid.email,
  file:id
})
  
  useEffect(() => {
    get(child(dbRef, `mountbook/entry/`)).then((snapshot) => {
      if (snapshot.exists()) {
      setData(Object.values(snapshot.val()).filter((item)=>(item.email===props.uid.email)))
      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      console.error(error);
    });
  }, [])

  const getx=()=>{
    get(child(dbRef, `mountbook/entry/`)).then((snapshot) => {
      if (snapshot.exists()) {
      setData(Object.values(snapshot.val()).filter((item)=>(item.email===props.uid.email)))
      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      console.error(error);
    });
  }
  


const Addproduct=()=>{

  if (Entry.title!==''&&parseFloat(Entry.dr)>0) {
    const newPostKey = push(child(ref(db),  `mountbook/entry/`)).key;
              update(ref(db, 'mountbook/entry/'+ newPostKey+'/'), {...Entry,
        PushKey: newPostKey
      }).then(()=>{getx();setShow(false);setError(null)} );
  }else{
    setError('Enter Currect Data')
  }

  
  }

  const logout=()=>{
    signOut(auth).then(() => {
      // setAUser(false)
      // window.reload();
    }).catch((error) => {
      
    });
  }


  return (
    <div>

<div style={{
      display:'flex',
      backgroundColor:'#6EE788',
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
      alignItems:'center',
      justifyContent:'space-between',
      padding:'0px 10px',
  }}>
      <div >
          <h1 style={{
              color:'black',
              fontSize:22,
              fontWeight:700
          }}>MountBook</h1>

      </div>

      <div style={{
        fontSize:16,
        margin:0,
       
        padding:10,
        color:'#972C2C'
      }}>
        <p style={{margin:0,padding:0,fontWeight:'bold'}}>Balance - ₹ {total().cr-total().dr}</p>
      </div>

      <div>
        
      <i style={
          {
              padding:10,
              backgroundColor:'#EAEAEA',
              borderRadius:20,
          }
      } onClick={logout} className="fa-solid fa-right-from-bracket"></i>
      </div>
  </div>
      
      <div style={{
        width:60,
        height:60,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:'#2989D8',
        borderRadius:40,
        position:'fixed',
        bottom:30,
        right:30
      }} onClick={()=>setShow(true)}>
      <i style={{
        fontSize:20,
        color:'white'
      }} class="fa-solid fa-plus"></i>
      </div>


      <table style={{
        width:'100%',
        fontSize:12
      }}>
  <tr style={{
    backgroundColor:'#6EE788'
  }}>
    <th style={{width:'5%',padding:'8px 0px'}}>Sno.</th>
    <th style={{width:'20%'}}>Date</th>
    <th style={{width:'30%'}}>Perticular</th>
    <th style={{width:'20%'}}>Dr</th>
    <th style={{width:'20%'}}>Cr</th>
  </tr>

{
  Data.map((item,index)=>(
    <tr style={{backgroundColor:color(index+1)}}>
    <td style={{padding:'5px 0px',textAlign:'center'}}>{index+1}</td>
    <td>{item.date}</td>
    <td>{item.title}</td>
    <td>{item.dr}</td>
    <td>{item.cr}</td>
  </tr>
  ))
}

{Data.length>0&&<tr style={{backgroundColor:'#52FDCE'}}>
    <td style={{padding:'5px 0px',textAlign:'center'}}></td>
    <td></td>
    <td style={{padding:'8px 0px',textAlign:'center'}}>Total</td>
    <td>{total().dr}</td>
    <td>{total().cr}</td>
  </tr>
}

</table>

{Show&&
<div style={{
  position:'fixed',
  right:20,
  left:20,
  padding:20,
  textAlign:'center',
  bottom:20,
  backgroundColor:'white',
  border:'1px solid black'
}}>
{Error&&<p style={{fontSize:12,color:'red'}}>{Error}</p>}
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
}} type='text' placeholder='Enter Perticular' onChange={(e)=>setEntry({...Entry,title:e.target.value})}/>
<input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px'
  
}} type='number' placeholder='Amount' onChange={(e)=>setEntry({...Entry,dr:e.target.value})}/>
<FileUp x = {id} setX={setid} title='Receipt'/>
<button style={{
  padding:10,
  width:'87%',
  margin:'5px 0px'
}} onClick={Addproduct}>Add Entry</button>

<button style={{
  padding:10,
  width:'87%',
  margin:'5px 0px'
}} onClick={()=>setShow(false)}>Back</button>

</div>

}

    </div>
  )
}

export default Addbook
